export default __webpack_public_path__ + "static/media/map-marker-alt.b46c8d56.svg";